// extracted by mini-css-extract-plugin
export default {"main":"style_main__q7-2Z","big":"style_big__BsjGU","toggle":"style_toggle__Q-qoF"};